<div class="import-options-container">
    <div class="import-options-title">
        {{ 'aumico_annual_report_import_optional_settings_title' | i18next }}
    </div>

    <aum-toggle
        class="options-button"
        [aumFormControl]="form.controls['importBalanceAndIncomeSeparately']"
        [disabled]="!enableOptions"
    >
        {{ 'aumico_annual_report_import_balance_and_income_from_separate_files_option' | i18next }}
    </aum-toggle>

    <aum-toggle
        class="options-button"
        [aumFormControl]="form.controls['selectAnnualReportForUploadAndMappingAutoFill']"
        [disabled]="!enableOptions || uploadAndMappingAutoFillAnnualReportToggleDisabled"
    >
        {{ 'aumico_annual_report_import_select_annual_report_for_autofill_and_mapping' | i18next }}
    </aum-toggle>

    <div class="options-button" *ngIf="selectAnnualReportForUploadAndMappingAutoFillToggle">
        <button
            aum-icon-button
            color="accent"
            icon="lighting-light-bulb"
            [disabled]="!enableOptions"
            (click)="onChooseAnnualReportToAutofillFromButtonClicked()"
        >
            {{ 'aumico_annual_report_import_choose_annual_report_for_autofill_and_mapping_button' | i18next }}
        </button>
    </div>
</div>

<ham-modal
    *ngIf="showProjectList"
    [saveText]="'aumico_button_save' | i18next"
    (cancel)="showProjectList = false"
    (save)="onSaveSelectedAnnualReportForUploadAndMappingAutoFill()"
    [size]="'lg'"
    [disabled]="!selectedAnnualReportForUploadAndMappingAutoFill"
>
    <aumico-annualReport-project-selection-list-component
        [data]="dialogData"
        [autofillOptions]="autofillOptions"
        (rowSelected)="onRowSelected($event)"
        (selectedOptions)="onSelectedOptionsChange($event)"
        [currentLanguage]="userLanguage"
        [showAutofillOptions]="true"
        [activeArNavigation]="activeArNavigation"
    ></aumico-annualReport-project-selection-list-component>
</ham-modal>
